import Axios from 'axios';

const BASE_URL =  "/api/sms";

export default {

    send(data) {
        //return Axios.get(BASE_URL+"/smsapi?key="+data.key+"&to="+data.to+"&msg="+data.msg+"&sender_id="+data.senderid,{headers,crossDomain: true });
        return Axios.get(BASE_URL+"/send",{params:data});
      },
    getBalance(key) {
       // return Axios.get(BASE_URL+"/api/smsapibalance?key="+key);
       return Axios.get(BASE_URL+"/balance");
    },



}



// WEBPACK FOOTER //
// ./resources/assets/js/services/sms.js